import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  novalidate: ""
}
const _hoisted_2 = {
  key: 0,
  class: "govuk-fieldset"
}
const _hoisted_3 = { class: "govuk-fieldset__heading" }
const _hoisted_4 = {
  key: 1,
  novalidate: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.formFieldsets.length > 0)
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formFieldsets, (fieldset, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (!fieldset.hide && Object.keys(fieldset.fields).length)
              ? (_openBlock(), _createElementBlock("fieldset", _hoisted_2, [
                  _withDirectives(_createElementVNode("legend", {
                    class: _normalizeClass(_ctx.getFieldSetClassString(fieldset))
                  }, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(fieldset.text), 1)
                  ], 2), [
                    [_vShow, fieldset.visible]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldset.fields, (field, index) => {
                    return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(field.type), {
                      onInputValueUpdated: _ctx.handleInputValueUpdated,
                      key: index,
                      field: field,
                      fieldset: fieldset
                    }, null, 8, ["onInputValueUpdated", "field", "fieldset"])), [
                      [_vShow, field.visible]
                    ])
                  }), 128))
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(fieldset.fields, (field, index) => {
                  return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(field.type), {
                    onInputValueUpdated: _ctx.handleInputValueUpdated,
                    key: index,
                    field: field,
                    fieldset: fieldset
                  }, null, 8, ["onInputValueUpdated", "field", "fieldset"])), [
                    [_vShow, field.visible]
                  ])
                }), 128))
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formButtons, (button, index) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(button.type), {
            onSubmitTriggered: _ctx.handleSubmitTriggered,
            key: index,
            name: index,
            button: button
          }, null, 8, ["onSubmitTriggered", "name", "button"]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("form", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formFields, (field, index) => {
          return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(field.type), {
            onInputValueUpdated: _ctx.handleInputValueUpdated,
            key: index,
            field: field
          }, null, 8, ["onInputValueUpdated", "field"])), [
            [_vShow, field.visible]
          ])
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formButtons, (button, index) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(button.type), {
            onSubmitTriggered: _ctx.handleSubmitTriggered,
            key: index,
            name: index,
            button: button
          }, null, 8, ["onSubmitTriggered", "name", "button"]))
        }), 128))
      ]))
}